import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrganizationService } from '../organization.service';
import { UserService } from 'src/app/services/user.service';
import { MatTableDataSource } from '@angular/material/table';
import { User } from 'src/app/services/user';
import { BaseComponent } from 'src/app/base/base.component';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';


// ✅ Define Model Above @Component
class SessionTimeout {
  organizationId: string;
  operatorTimeout: number;
  analystTimeout: number;
  adminTimeout: number;

  constructor(data?: Partial<SessionTimeout>) {
    this.organizationId = data?.organizationId || '';
    this.operatorTimeout = data?.operatorTimeout || 15;
    this.analystTimeout = data?.analystTimeout || 30;
    this.adminTimeout = data?.adminTimeout || 60;
  }
}

@Component({
    selector: 'app-organizations-sessiontimeout',
    templateUrl: './organizations-sessiontimeout.component.html',
    styleUrls: ['./organizations-sessiontimeout.component.css'],
    standalone: false
})
export class OrganizationsSessiontimeoutComponent implements OnInit {
  
  sessionTimeoutForm: FormGroup;
  sessionTimeout: SessionTimeout;
 
  sessionTimeoutData: any[] = [];
  loading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private organizationService: OrganizationService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<OrganizationsSessiontimeoutComponent>,
    private snackBar: MatSnackBar
  ) {
   // this.organizationId=data.orgnizationId
   // this.organizationName=data.orgnizationName
    // ✅ Initialize Model
    this.sessionTimeout = new SessionTimeout({ organizationId: data.organizationId });
  }

  async ngOnInit(): Promise<void> {
    this.sessionTimeoutForm = this.fb.group({
      operatorTimeout: [0, [Validators.required, Validators.min(1)]],
      analystTimeout: [0, [Validators.required, Validators.min(1)]],
      adminTimeout: [0, [Validators.required, Validators.min(1)]],
    });
  
    await this.loadSessionTimeouts();
  }
  async loadSessionTimeouts(): Promise<void> {
    this.loading = true;
    try {
      this.sessionTimeoutData = await this.organizationService
        .getSessionTimeoutsByOrgId(this.data.orgnizationId)
        .toPromise(); // Convert Observable to Promise for async/await
   // Map roleId to form fields
   const operator = this.sessionTimeoutData.find(item => item.roleId === 4); // Operator
   const analyst = this.sessionTimeoutData.find(item => item.roleId === 3);  // Analyst
   const admin = this.sessionTimeoutData.find(item => item.roleId === 2);    // Admin

   this.sessionTimeoutForm.patchValue({
     operatorTimeout: operator?.timeout ?? 15,
     analystTimeout: analyst?.timeout ?? 30,
     adminTimeout: admin?.timeout ?? 60
   });

 } catch (error) {
   console.error('Failed to fetch session timeouts:', error);
   this.sessionTimeoutData = [];
 } finally {
   this.loading = false;
 }
}
async saveTimeouts() {
  console.log('this.sessionTimeoutForm.value:', this.sessionTimeoutForm.value);
  if (this.sessionTimeoutForm.invalid) {
    this.snackBar.open('Please enter valid timeout values.', 'Close', { duration: 3000 });
    return;
  }

  const formValues = this.sessionTimeoutForm.value;

  // roleId to formControlName map
  const roleMapping = {
    4: 'operatorTimeout',
    3: 'analystTimeout',
    2: 'adminTimeout'
  };

  const updatePromises: Promise<any>[] = [];

  this.sessionTimeoutData.forEach(item => {
    const formControlName = roleMapping[item.roleId];
    const timeout = formValues[formControlName];
    console.log('timeout:', timeout);
    if (timeout !== undefined && timeout !== null) {
      const sessionTimeoutUpdate = {
        id: item.id,
        timeout: timeout,
        status: true
      };

      updatePromises.push(
        this.organizationService.updateOrganizationSessionTimeout(sessionTimeoutUpdate)
      );
    }
  });

  try {
    await Promise.all(updatePromises);
    this.snackBar.open('Session timeouts updated successfully!', 'Close', { duration: 3000 });
    this.dialogRef.close(true);
  } catch (error) {
    console.error('Error while updating session timeouts:', error);
    this.snackBar.open('Failed to update session timeouts.', 'Close', { duration: 3000 });
  }
}


  onCancel(): void {
    this.dialogRef.close();
  }
  
}
